const updates = [
  {
    time: '2026.07.30 14:32',
    title: '某知名歌手被前经纪人实名举报偷税漏税，涉及金额超千万',
    tag: '最新',
    tagColor: 'bg-primary-500/80',
  },
  {
    time: '2026.07.30 11:15',
    title: '科技巨头CEO内部邮件曝光：承认产品存在重大安全隐患',
    tag: '独家',
    tagColor: 'bg-primary-500/80',
  },
  {
    time: '2026.07.30 08:47',
    title: '热门综艺节目导演组集体辞职，节目录制全面暂停',
    tag: '突发',
    tagColor: 'bg-accent-500/80',
  },
  {
    time: '2026.07.29 22:30',
    title: '知名投资机构合伙人涉嫌内幕交易被证监会立案调查',
    tag: '跟进',
    tagColor: 'bg-secondary-500/80',
  },
  {
    time: '2026.07.29 18:22',
    title: '国际电竞大赛选手集体罢赛，控诉主办方拖欠奖金长达半年',
    tag: '热议',
    tagColor: 'bg-accent-500/80',
  },
  {
    time: '2026.07.29 15:08',
    title: '百万粉丝美食博主被曝食材造假，多个合作品牌紧急解约',
    tag: '翻车',
    tagColor: 'bg-primary-500/80',
  },
  {
    time: '2026.07.29 10:45',
    title: '上市房企债券违约风波升级，多地项目停工业主集体维权',
    tag: '持续',
    tagColor: 'bg-secondary-500/80',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            暗网吃瓜实时追踪，最新爆料动态实时更新，不错过任何一个大瓜
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative">
            <div className="absolute left-4 top-0 bottom-0 w-px bg-background-300/50 hidden sm:block"></div>
            <div className="flex flex-col gap-4">
              {updates.map((item, i) => (
                <div key={i} className="flex gap-4 items-start group">
                  <div className="relative z-10 w-8 h-8 rounded-full bg-background-200 border-2 border-background-300/50 flex items-center justify-center flex-shrink-0 hidden sm:flex group-hover:border-primary-500/50 transition-colors">
                    <div className={`w-2.5 h-2.5 rounded-full ${i === 0 ? 'bg-primary-500 animate-pulse' : 'bg-background-400'}`}></div>
                  </div>
                  <div className="flex-1 bg-background-200/80 border border-background-300/30 rounded-xl p-4 hover:border-primary-500/20 transition-all cursor-pointer">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                      <span className={`text-[10px] px-1.5 py-0.5 rounded text-background-50 whitespace-nowrap ${item.tagColor}`}>
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">{item.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}